export interface IFilterData {
    filterBy: number
    centerId: number,
}